import { SvgProps } from "components/icons/types";

export const PriceTagOutline = (props: SvgProps) => (
  <svg
    {...props}
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.91257 5.39929C4.14065 5.62738 4.14065 5.99663 3.91257 6.22413C3.68448 6.45221 3.31523 6.45221 3.08773 6.22413C2.85965 5.99604 2.85965 5.62679 3.08773 5.39929C3.31582 5.17121 3.68507 5.17121 3.91257 5.39929ZM11.9929 8.94888L11.6633 9.27846C11.6476 9.99771 11.3687 10.7117 10.8262 11.2612L8.97882 13.1325C8.42873 13.6896 7.6949 13.9976 6.91207 14H6.90215C6.1234 14 5.39132 13.6966 4.84065 13.146L0.514649 8.85671C0.135483 8.47813 -0.0476842 7.95721 0.0106492 7.42579L0.456899 3.39146C0.486649 3.12546 0.692566 2.91371 0.957399 2.87754L4.97598 2.32804C5.51965 2.25571 6.06682 2.44063 6.45065 2.82446L10.8111 7.14813C11.0368 7.37388 11.2177 7.62821 11.3541 7.89946C11.8278 7.21929 11.7613 6.26904 11.1546 5.66238L6.72657 1.34279C6.59298 1.20921 6.40865 1.14738 6.23015 1.17246L2.21157 1.72196C1.89132 1.76513 1.5979 1.54171 1.55415 1.22321C1.51098 0.904125 1.7344 0.610126 2.0529 0.566376L6.07207 0.0162923C6.60932 -0.0601244 7.16232 0.127709 7.54673 0.513292L11.9736 4.83288C13.1088 5.96746 13.1152 7.81196 11.9923 8.94946L11.9929 8.94888ZM9.9874 7.97471L5.62698 3.65104C5.4969 3.52096 5.31432 3.46088 5.1329 3.48363L1.56582 3.97188L1.16973 7.55354C1.15048 7.73029 1.21115 7.90413 1.33715 8.02954L5.66315 12.3188C5.99507 12.6513 6.43432 12.8327 6.90157 12.8327H6.9074C7.37757 12.8315 7.81798 12.6466 8.14757 12.3118L9.99498 10.4405C10.6687 9.75796 10.6652 8.65137 9.98682 7.97354L9.9874 7.97471Z"
      fill="url(#paint0_linear_6761_6460)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6761_6460"
        x1="5.17774"
        y1="1.793"
        x2="14.6564"
        y2="17.7635"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E693BB" />
        <stop offset="0.405909" stop-color="#763EF3" />
        <stop offset="0.695572" stop-color="#6731F9" />
        <stop offset="1" stop-color="#4A23B2" />
      </linearGradient>
    </defs>
  </svg>
);
